/*
 * @Author: zyy
 * @Date: 2023-03-28 12:13:43
 * @LastEditTime: 2025-02-24 10:51:49
 * @FilePath: /tjzhsq-admin/src/io/charge_type.js
 * @Description: yahu~
 * 
 */
import Axios from 'axios';
import Qs from 'qs';

export default {

  // 收费类型分页列表
  listPage(
    keyword,
    page,
    per_page
  ) {
    return Axios.get('/shjf/api/admin/expenses-type', {
      params: {
        keyword,
        page,
        per_page
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    });
  },

  // 收费类型列表
  list() {
    return Axios.get('/shjf/api/admin/expenses-type/list');
  },

  // 添加收费类型
  add(
    name,
    remark
  ) {
    return Axios.post('/shjf/api/admin/expenses-type', {
      name,
      remark
    });
  },

  // 编辑收费类型
  edit(
    id,
    name,
    remark
  ) {
    return Axios.put(`/shjf/api/admin/expenses-type/${id}`, {
      name,
      remark
    });
  },

  // 删除收费类型
  del(
    id
  ) {
    return Axios.delete(`/shjf/api/admin/expenses-type/${id}`);
  },

  // 收费类型启用禁用
  switchStatus(
    id
  ) {
    return Axios.put(`/shjf/api/admin/expenses-type/${id}/show`);
  },

}